import React, { useState } from 'react'
import { Button, Slider } from '@alifd/next'
import styles from './index.module.scss'
import {
  flowShare,
  flowPM,
  flowCollection,
  flowStatistics,
  flowAchievement,
  hoverFlowShare,
  hoverFlowPM,
  hoverFlowCollection,
  hoverFlowStatistics,
  hoverFlowAchievement,
} from 'portal/assets/images/index'

interface FlowItemProps {
  id: number,
  project: string,
  description: string,
  image: any,
  hoverImage: any,
  btn: string,
  link: string,
}

export default function CompleteFlow() {
  const slides: FlowItemProps[] = [
    {
      id: 1,
      project: '数据共享系统',
      description: '申请使用数据共享',
      image: flowShare,
      hoverImage: hoverFlowShare,
      btn: '查看详情',
      link: '/apps/dsp?path=/studies',
    },
    {
      id: 2,
      project: '项目管理系统',
      description: '项目立项、伦理审批与各类协议管理',
      image: flowPM,
      hoverImage: hoverFlowPM,
      btn: '查看详情',
      link: '/apps/pm?path=/index.jsp?sysId=i',
    },
    {
      id: 3,
      project: '数据采集系统',
      description: '收集符合CDISC国际标准的基线和随访数据',
      image: flowCollection,
      hoverImage: hoverFlowCollection,
      btn: '查看详情',
      link: '/apps/edc',
    },
    {
      id: 4,
      project: '统计分析系统',
      description: '利用在线统计与关联性分析工具得出结论',
      image: flowStatistics,
      hoverImage: hoverFlowStatistics,
      btn: '查看详情',
      link: '/apps/sat',
    },
    {
      id: 5,
      project: '成果管理系统',
      description: '科研成果的转化和应用',
      image: flowAchievement,
      hoverImage: hoverFlowAchievement,
      btn: '查看详情',
      link: '',
    }
  ]
  function RenderSlides (props: FlowItemProps) {
    const { id, project, description, image, hoverImage, btn, link } = props
    const [hover, setHover] = useState<any>(image)
    function onMouseOver() {
      setHover(hoverImage)
    }
    function onMouseLeave() {
      setHover(image)
    }
    return (
      <div className={ styles.slickSlide } key={ id } onMouseEnter={onMouseOver} onMouseLeave={onMouseLeave}>
        <a href={ link } target="_blank" rel="noopener noreferrer" style={{ color: '#333' }}>
          <div className={ styles.carousel }>
            <h4 className={ styles.system }>
              <img src={ hover } alt="图标" style={{ paddingLeft: 35, paddingRight: 12 }} />
              { project }
            </h4>
            <p className={ styles.triangle }></p>
            <span className={ styles.dots }>•</span>
          </div>
          <div className={ styles.description }>{ description }</div>
          <div className={ styles.btn } style={{ height: 50, paddingTop: 18, paddingRight: 15 }}>
            <Button>{ btn }</Button>
          </div>
        </a>
      </div>
    )
  }

  return (
    <React.Fragment>
      {/* 临床研究全流程解决方案 */}
      <div className={ styles.completeFlow }>
        <div style={{ width: 1200, margin: 'auto', textAlign: 'center' }}>
          <h2 style={{ margin: 0, fontSize: 28, paddingTop: 70 }}>临床研究全流程解决方案<p></p></h2>
          <Button style={{ marginTop: 25, fontSize: 16, width: 132, height: 42, color: '#fff' }}>申请开展研究</Button>
          <div style={{ marginTop: 50 }}>
            <Slider
              slidesToShow={4}
              arrowPosition="outer"
              lazyLoad
              dots={false}>
              {slides.map(RenderSlides)}
            </Slider>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
